import { useState, useRef, useEffect } from 'react';
import {
    Button,
    Popper,
    Box,
    Paper,
    Fade,
    Skeleton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { KeyboardArrowDown, Wallet } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import CreditDetails from './CreditDetails';
import { useCreditsAndPlans } from './context';

export default function CreditPopover() {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const popperRef = useRef(null);

    const timerRef = useRef(null);

    const { credits, creditsLoading } = useCreditsAndPlans()
    const { openCreditPopper } = useSelector(state => state.entities.tutorial)

    const handleMouseEnter = () => {
        clearTimeout(timerRef.current);
        timerRef.current = null
        setOpen(true);
    };

    const handleMouseLeave = () => {
        timerRef.current = setTimeout(() => {
            setOpen(false);
        }, 200);
    };

    // Effect to control popper state based on tutorial
    useEffect(() => {
        if (openCreditPopper) {
            clearTimeout(timerRef.current);
            setOpen(true);
        } else if (!openCreditPopper && open) {
            // Only close if tutorial explicitly sets it to false
            setOpen(false);
        }
    }, [openCreditPopper]);

    return (
        <div>
            <Button
                ref={anchorRef}
                color="white"
                variant="outlined"
                onMouseEnter={() => {
                    handleMouseEnter();
                }}
                onMouseLeave={() => {
                    handleMouseLeave();
                }}
                sx={{
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                }}
                endIcon={<KeyboardArrowDown color='white' />}
                startIcon={<Wallet color='white' />}
                id="toobar-credit-details"
            >
                {
                    creditsLoading ?
                        <Skeleton
                            variant="text"
                            width={80}
                            height={20}
                        />
                        :
                        `${credits} ${t("currency.SAR")}`
                }
            </Button>

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom"
                transition
                disablePortal
                sx={{ zIndex: 1300 }}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper
                            ref={popperRef}
                            elevation={3}
                            id='popper-credit-details'
                            onMouseEnter={() => {
                                handleMouseEnter();
                            }}
                            onMouseLeave={() => {
                                handleMouseLeave();
                            }}
                            sx={{ p: 2, mt: 2 }}
                        >
                            <Box width={300}>
                                <CreditDetails />
                            </Box>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </div>
    );
}